import axios from "axios";
import { APIClient } from "./api_helper";

import * as url from "./url_helper";
import qs from "qs";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("authUser");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postJwtRegister = (url, data) => {
  return api.create(url, data).catch((err) => {
    var message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Хуудас олдсонгүй!";
          break;
        case 500:
          message = "Алдаа гарлаа, Support team холбогдоно уу!";
          break;
        case 401:
          message = "Нэвтрэх нэр/нууц үг буруу байна";
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};

// Login Method
export const postREJwtLogin = (data) => api.create(url.POST_LOGIN, data);

export const getSignIn = (data) => api.create(url.POST_LOGIN, data);

// CRM
// get Users
export const getUsers = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    // Extract the accessToken
    token = parsedUser.accessToken;

    // if (token) {
    //   console.log("Access Token:", token);
    // } else {
    //   console.log("No access token found.");
    // }
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_USERS, {
    headers: {
      Authorization: `Bearer ${token}`, // Correct format for the Authorization header
    },
  });
};

// add User
export const addNewUser = (contact) => api.create(url.ADD_NEW_USER, contact);

// add Employee
export const addNewEmployee = (contact) =>
  api.create(url.ADD_NEW_EMPLOYEE, contact);

// update User
export const updateUser = (contact) =>
  api.put(url.UPDATE_USER + "/" + contact._id, contact);

export const updateEmployee = (contact) =>
  api.put(url.UPDATE_EMPLOYEE + "/" + contact._id, contact);

// heartbeat User
export const heartbeatUser = (contact) =>
  api.put(url.UPDATE_HEARTBEAT_USER + "/" + contact._id, contact);

export const changePassword = (contact) =>
  api.put(url.CHANGE_PWD + "/" + contact._id, contact);

// delete User
export const deleteUser = (contact) =>
  api.delete(url.DELETE_USER + "/" + contact);

// Companies
// get Companies
export const getCompanies = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    // Extract the accessToken
    token = parsedUser.accessToken;

    // if (token) {
    //   console.log("Access Token:", token);
    // } else {
    //   console.log("No access token found.");
    // }
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_COMPANIES, {
    headers: {
      Authorization: `Bearer ${token}`, // Correct format for the Authorization header
    },
  });
};

// add Company
export const addNewCompany = (company) =>
  api.create(url.ADD_NEW_COMPANY, company);

// update Company
export const updateCompany = (company) =>
  api.put(url.UPDATE_COMPANY + "/" + company._id, company);

// delete Company
export const deleteCompany = (company) =>
  api.delete(url.DELETE_COMPANY + "/" + company);

// Containers
// get Containers
export const getContainers = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    // Extract the accessToken
    token = parsedUser.accessToken;

    if (token) {
      //console.log("Access Token:", token);
    } else {
      console.log("No access token found.");
    }
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_CONTAINERS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getBWarehouses = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    // Extract the accessToken
    token = parsedUser.accessToken;

    if (token) {
      //console.log("Access Token:", token);
    } else {
      console.log("No access token found.");
    }
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_CONTAINERS_BWAREHOUSES, {
    headers: {
      Authorization: `Bearer ${token}`, // Correct format for the Authorization header
    },
  });
};

export const getContainersGetFilters = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const {
    activeType = "",
    number = "",
    type = [],
    company = "",
    manifest = "",
    lombo = "",
    vagon = "",
    packageName = "",
    egnee = "",
    floor = "",
    urgent = "",
    emptied = "",
    startDate = "",
    endDate = "",
    page = 1,
    limit = 30,
  } = filters;

  return api.get(url.GET_CONTAINERS_GETFILTERS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      activeType,
      number,
      type,
      company,
      manifest,
      lombo,
      vagon,
      packageName,
      egnee,
      floor,
      urgent,
      emptied,
      startDate,
      endDate,
      page: filters.page,
      pageSize: 30,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

export const getContainersGetFiltersExport = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const {
    activeType = "",
    number = "",
    type = [],
    company = "",
    manifest = "",
    lombo = "",
    vagon = "",
    packageName = "",
    egnee = "",
    floor = "",
    urgent = "",
    emptied = "",
    startDate = "",
    endDate = "",
    page = 1,
    limit = 100,
  } = filters;

  return api.get(url.GET_CONTAINERS_GETFILTERS_EXPORT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      activeType,
      number,
      type,
      company,
      manifest,
      lombo,
      vagon,
      packageName,
      egnee,
      floor,
      urgent,
      emptied,
      startDate,
      endDate,
      page: filters.page,
      pageSize: 30,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

// get Containers
export const getContainersFilterAll = () =>
  api.get(url.GET_CONTAINERS_FILTERALL);

// get Containers
export const getContainersFilter = () => api.get(url.GET_CONTAINERSFILTER);

// get Container
export const getContainerByID = (container) => {
  return api.get(url.GET_CONTAINER_BYID + "?cid=" + container);
};

export const getContainersStats = (beginDate, lastDate, company) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_CONTAINERS_STATS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      company,
    },
  });
};

export const getContainersGenStats = (beginDate, lastDate, company) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_CONTAINERS_GENSTATS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      company,
    },
  });
};

// add Container
export const addNewContainer = (container) =>
  api.create(url.ADD_NEW_CONTAINER, container);

// update Container
export const updateContainer = (container) =>
  api.put(url.UPDATE_CONTAINER + "/" + container._id, container);

// delete Container
export const deleteContainer = (container) =>
  api.delete(url.DELETE_CONTAINER + "/" + container);

// ============== NEW =========== add Container
export const addNewContainerGetFilters = (container) =>
  api.create(url.ADD_NEW_CONTAINER, container);

// update Container
export const updateContainerGetFilters = (container) =>
  api.put(url.UPDATE_CONTAINER + "/" + container._id, container);

// delete Container
export const deleteContainerGetFilters = (container) =>
  api.delete(url.DELETE_CONTAINER + "/" + container);

// get Additional Fees
export const getAdditionalFees = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    // Extract the accessToken
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_ADDFEES, {
    headers: {
      Authorization: `Bearer ${token}`, // Correct format for the Authorization header
    },
  });
};

// export const getAdditionalFees = () =>
//   api.get(url.GET_ADDFEES);

// add Additional Fee
export const addNewAdditionalFee = (additionalfee) =>
  api.create(url.ADD_NEW_ADDFEE, additionalfee);

// update Additional Fee
export const updateAdditionalFee = (additionalfee) =>
  api.put(url.UPDATE_ADDFEE + "/" + additionalfee._id, additionalfee);

// delete Additional Fee
export const deleteAdditionalFee = (additionalfee) =>
  api.delete(url.DELETE_ADDFEE + "/" + additionalfee);

// get Various Fees
export const getVFees = (beginDate, lastDate) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_VFEES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
    },
  });
};

export const getVFeesGetFilters = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const {
    activeType = "",
    vf_number = "",
    vf_container_number = "",
    vf_company = "",
    beginDate = "",
    lastDate = "",
    page = 1,
    limit = 100,
  } = filters;

  return api.get(url.GET_VFEES_GETFILTERS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      activeType,
      vf_number,
      vf_container_number,
      vf_company,
      beginDate,
      lastDate,
      page: filters.page,
      pageSize: 100,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

export const getVFeesGetFiltersExport = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const {
    activeType = "",
    vf_number = "",
    vf_container_number = "",
    vf_company = "",
    beginDate = "",
    lastDate = "",
    page = 1,
    limit = 100,
  } = filters;

  return api.get(url.GET_VFEES_GETFILTERS_EXPORT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      activeType,
      vf_number,
      vf_container_number,
      vf_company,
      beginDate,
      lastDate,
      page: filters.page,
      pageSize: 100,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

export const getVFeesByClient = (beginDate, lastDate, company_name) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_VFEES_BYCLIENT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      company_name,
    },
  });
};

export const getVFeesBalance = (beginDate, lastDate) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_VFEES_BALANCE, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
    },
  });
};

export const getVFeesBalanceClient = (beginDate, lastDate, company_name) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_VFEES_BALANCE_CLIENT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      company_name,
    },
  });
};

export const getVFeesCompany = (beginDate, lastDate, company_name) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_VFEES_COMPANY, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      company_name,
    },
  });
};

export const getVFeesDeleted = (beginDate, lastDate) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_VFEES_DELETED, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
    },
  });
};

export const getVFeesFindByID = (vfee) => {
  return api.get(url.FIND_BYID + "/" + vfee);
};

export const getVFeeFindByNumber = (vfee) => {
  return api.get(url.FIND_VFEE + "/" + vfee);
};

export const getVFeeByNumber = (vfee) => {
  return api.get(url.GET_VFEE_BYNUMBER + "?vfid=" + vfee);
};

// add Various Fee
export const addNewVFee = (vfee) => api.create(url.ADD_NEW_VFEE, vfee);

// update Various Fee
export const updateVFee = (vfee) =>
  api.put(url.UPDATE_VFEE + "/" + vfee._id, vfee);

// delete Various Fee
export const deleteVFee = (id) => api.delete(`${url.DELETE_VFEE}/${id}`);

export const lockUnlockVFees = (vfee) =>
  api.put(url.UPDATE_VFEE_LOCK + "/" + vfee._id, vfee);

// get Receivers by container number
export const getReceivers = ({ container_id, container_number }) => {
  // console.log("API received container_id:", container_id);
  // console.log("API received container_number:", container_number);

  return api.get(url.GET_FIND_RECEIVERS, {
    params: {
      container_id,
      container_number,
    },
  });
};

export const getReceiversGetFilters = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const {
    activeType = "",
    mode = "",
    number = "",
    company = "",
    vagon = "",
    packageName = "",
    rc_receiver = "",
    startDate = "",
    endDate = "",
    page = 1,
    pageSize = 30,
  } = filters;

  return api.get(url.GET_RECEIVERS_GETFILTERS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      activeType,
      mode,
      number,
      company,
      vagon,
      packageName,
      rc_receiver,
      startDate,
      endDate,
      page: filters.page,
      pageSize: filters.pageSize || 30,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

export const getReceiversGetFiltersExport = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const {
    activeType = "",
    number = "",
    company = "",
    vagon = "",
    packageName = "",
    rc_receiver = "",
    startDate = "",
    endDate = "",
    page = 1,
    pageSize = 30,
  } = filters;

  return api.get(url.GET_RECEIVERS_GETFILTERS_EXPORT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      activeType,
      number,
      company,
      vagon,
      packageName,
      rc_receiver,
      startDate,
      endDate,
      page: filters.page,
      pageSize: 30,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

// add Receiver
export const addNewReceiver = (receiver) =>
  api.create(url.ADD_NEW_RECEIVER, receiver);

// add ReceiverClient
export const addNewReceiverClient = (receiver) =>
  api.create(url.ADD_NEW_RECEIVER_CLIENT, receiver);

// update Receiver
export const updateReceiver = (receiver) =>
  api.put(url.UPDATE_RECEIVER + "/" + receiver._id, receiver);

// delete Receiver
export const deleteReceiver = (receiver) =>
  api.delete(url.DELETE_RECEIVER + "/" + receiver);

// Vehicles
// get Vehicles
export const getVehicles = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_VEHICLES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getVehiclesGetFilters = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const {
    activeType = "",
    vh_container_number = "",
    vh_company = "",
    vh_aral_number = "",
    vh_owner_name = "",
    startDate,
    endDate,
    page = 1,
    pageSize = 30,
  } = filters;

  // params-д зөвхөн утгатайг оруулна
  const params = {
    activeType,
    vh_container_number,
    vh_company,
    vh_aral_number,
    vh_owner_name,
    page,
    pageSize,
  };

  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  return api.get(url.GET_VEHICLES_GETFILTERS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

export const getVehiclesGetFiltersExport = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const {
    activeType = "",
    vh_container_number = "",
    vh_company = "",
    vh_aral_number = "",
    vh_owner_name = "",
    startDate = "",
    endDate = "",
    page = 1,
    limit = 30,
  } = filters;

  return api.get(url.GET_VEHICLES_GETFILTERS_EXPORT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      activeType,
      vh_container_number,
      vh_company,
      vh_aral_number,
      vh_owner_name,
      startDate,
      endDate,
      page: filters.page,
      pageSize: 30,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

// add Vehicle
export const addNewVehicle = (vehicle) =>
  api.create(url.ADD_NEW_VEHICLE, vehicle);

// update Vehicle
export const updateVehicle = (vehicle) =>
  api.put(url.UPDATE_VEHICLE + "/" + vehicle._id, vehicle);

// delete Vehicle
export const deleteVehicle = (vehicle) =>
  api.delete(url.DELETE_VEHICLE + "/" + vehicle);

export const getClientVehicles = (company_name) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_CLIENT_VEHICLES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      company_name,
    },
  });
};

// Orders
// get Orders
export const getOrders = (beginDate, lastDate, employee) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_ORDERS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      employee,
    },
  });
};

// get getClientOrders
export const getClientOrders = (beginDate, lastDate, company) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_CLIENT_ORDERS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      company,
    },
  });
};

// get OrdersFR
export const getOrdersbyFR = (beginDate, lastDate, company) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_ORDERS_BYFR, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      company,
    },
  });
};

export const getQuotesStats = (beginDate, lastDate, company, employee) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_QUOTES_STATS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      company,
      employee,
    },
  });
};

export const getOrdersStats = (beginDate, lastDate, company, employee) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_ORDERS_STATS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      company,
      employee,
    },
  });
};

// add Order
export const addNewOrder = (order) => api.create(url.ADD_NEW_ORDER, order);

// update Order
export const updateOrder = (order) =>
  api.put(url.UPDATE_ORDER + "/" + order._id, order);

// realbackend_helper.js
export const updateOrdersBulk = (orders) => {
  return api.put(url.UPDATE_BULK_ORDER, { orders });
};

// delete Order
export const deleteOrder = (order) =>
  api.delete(url.DELETE_ORDER + "/" + order);

// Quotes
// get Quotes
export const getQuotes = (beginDate, lastDate, employee) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_QUOTES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      employee,
    },
  });
};

// add Quote
export const addNewQuote = (quote) => api.create(url.ADD_NEW_QUOTE, quote);

// update Quote
export const updateQuote = (quote) =>
  api.put(url.UPDATE_QUOTE + "/" + quote._id, quote);

// delete Quote
export const deleteQuote = (quote) =>
  api.delete(url.DELETE_QUOTE + "/" + quote);

// WebQuotation
// get WebQuotation
export const getWebQuotation = (beginDate, lastDate, employee) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_WEBQUOTATION, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      employee,
    },
  });
};

// add WebQuotation
export const addNewWebQuotation = (wquote) =>
  api.create(url.ADD_NEW_WEBQUOTATION, wquote);

// update WebQuotation
export const updateWebQuotation = (wquote) =>
  api.put(url.UPDATE_WEBQUOTATION + "/" + wquote._id, wquote);

// delete WebQuotation
export const deleteWebQuotation = (wquote) =>
  api.delete(url.DELETE_WEBQUOTATION + "/" + wquote);

// OrdersReceivers
// get Receivers
export const getOrdersReceivers = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_ORDERS_RECEIVERS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getOrdersReceiversByName = (ordersReceivers = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const { name = "" } = ordersReceivers;

  return api.get(url.GET_ORDERS_RECEIVERS_FIND, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      name,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

// add OrderReceiver
export const addNewOrderReceiver = (orderReceiver) =>
  api.create(url.ADD_NEW_ORDER_RECEIVER, orderReceiver);

// update OrderReceiver
export const updateOrderReceiver = (orderReceiver) =>
  api.put(url.UPDATE_ORDER_RECEIVER + "/" + orderReceiver._id, orderReceiver);

// delete OrderReceiver
export const deleteOrderReceiver = (orderReceiver) =>
  api.delete(url.DELETE_ORDER_RECEIVER + "/" + orderReceiver);

// OrdersSenders
// get Senders
export const getOrdersSenders = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_ORDERS_SENDERS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getOrdersSendersByName = (sendersReceivers = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const { name = "", country = "" } = sendersReceivers;

  return api.get(url.GET_ORDERS_SENDERS_FIND, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      name,
      country,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

// add OrderSender
export const addNewOrderSender = (orderSender) =>
  api.create(url.ADD_NEW_ORDER_SENDER, orderSender);

// update OrderSender
export const updateOrderSender = (orderSender) =>
  api.put(url.UPDATE_ORDER_SENDER + "/" + orderSender._id, orderSender);

// delete OrderSender
export const deleteOrderSender = (orderSender) =>
  api.delete(url.DELETE_ORDER_SENDER + "/" + orderSender);

// CustomClearance
// getCustomClearance
export const getCustomClearances = (beginDate, lastDate, employee) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_CUSTOM_CLEARANCES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      employee,
    },
  });
};

// add CustomClearance
export const addNewCustomClearance = (customClearance) =>
  api.create(url.ADD_NEW_CUSTOM_CLEARANCE, customClearance);

// update CustomClearance
export const updateCustomClearance = (customClearance) =>
  api.put(
    url.UPDATE_CUSTOM_CLEARANCE + "/" + customClearance._id,
    customClearance
  );

// delete CustomClearance
export const deleteCustomClearance = (customClearance) =>
  api.delete(url.DELETE_CUSTOM_CLEARANCE + "/" + customClearance);

// CustomDeclaration
// getCustomDeclaration
export const getCustomDeclarations = (beginDate, lastDate, employee) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_CUSTOM_DECLARATIONS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beginDate,
      lastDate,
      employee,
    },
  });
};

// add CustomDeclaration
export const addNewCustomDeclaration = (customDeclaration) =>
  api.create(url.ADD_NEW_CUSTOM_DECLARATION, customDeclaration);

// update CustomDeclaration
export const updateCustomDeclaration = async (customDeclaration) => {
  console.log("Updating customDeclaration:", customDeclaration);

  if (!customDeclaration || !customDeclaration._id) {
    console.error("customDeclaration or ID is missing!");
    return null;
  }

  try {
    const response = await api.put(
      `${url.UPDATE_CUSTOM_DECLARATION}/${customDeclaration._id}`,
      customDeclaration
    );
    console.log("Update response:", response);
    return response;
  } catch (err) {
    console.error("Error updating customDeclaration:", err);
    return null;
  }
};

// delete CustomDeclaration
export const deleteCustomDeclaration = async (customDeclaration) => {
  //console.log("Deleting customDeclaration:", customDeclaration);

  if (!customDeclaration) {
    console.error("customDeclaration ID is missing!");
    return null;
  }

  try {
    const response = await api.delete(
      `${url.DELETE_CUSTOM_DECLARATION}/${customDeclaration}`
    );
    //console.log("Delete response:", response);
    return response;
  } catch (err) {
    console.error("Error deleting customDeclaration:", err);
    return null;
  }
};

// Invoices
// get Invoices
export const getInvoices = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    // Extract the accessToken
    token = parsedUser.accessToken;

    // if (token) {
    //   console.log("Access Token:", token);
    // } else {
    //   console.log("No access token found.");
    // }
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_INVOICES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// add Invoice
export const addNewInvoice = (invoice) =>
  api.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = (invoice) =>
  api.put(url.UPDATE_INVOICE + "/" + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = (invoice) =>
  api.delete(url.DELETE_INVOICE + "/" + invoice);

export const getInvoiceByNumber = (invoice) => {
  return api.get(url.GET_INVOICE_BYNUMBER + "?ivid=" + invoice);
};

// Documents
// get Documents
export const getDocuments = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_DOCUMENTS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// add Document
export const addNewDocument = (doc) => api.create(url.ADD_NEW_DOCUMENT, doc);

// update Document
export const updateDocument = (doc) =>
  api.put(url.UPDATE_DOCUMENT + "/" + doc._id, doc);

// delete Document
export const deleteDocument = (doc) =>
  api.delete(url.DELETE_DOCUMENT + "/" + doc);

// Archives
// get Archives
export const getArchives = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_ARCHIVES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// add Archive
export const addNewArchive = (doc) => api.create(url.ADD_NEW_ARCHIVE, doc);

// update Archive
export const updateArchive = (doc) =>
  api.put(url.UPDATE_ARCHIVE + "/" + doc._id, doc);

// delete Archive
export const deleteArchive = (doc) =>
  api.delete(url.DELETE_ARCHIVE + "/" + doc);

// ── Archive Folders ──────────────────────────────────────────────────
export const getFolders = ({ category, department } = {}) => {
  const token = getAuthToken();
  return api.get(url.GET_FOLDERS, {
    headers: { Authorization: `Bearer ${token}` },
    params: { category, department },
  });
};

export const addNewFolder = (data) => api.create(url.ADD_NEW_FOLDER, data);

export const deleteFolder = (id) =>
  api.delete(url.DELETE_FOLDER + "/" + id);

// Requests
// get Requests
export const getRequests = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_REQUESTS, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// add Request
export const addNewRequest = (request) =>
  api.create(url.ADD_NEW_REQUEST, request);

// update Request
export const updateRequest = (request) =>
  api.put(url.UPDATE_REQUEST + "/" + request._id, request);

// delete Request
export const deleteRequest = (request) =>
  api.delete(url.DELETE_REQUEST + "/" + request);

// MInvoices
// get MInvoices
export const getMInvoices = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_MINVOICES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// add MInvoice
export const addNewMInvoice = (minvoice) =>
  api.create(url.ADD_NEW_MINVOICE, minvoice);

// update MInvoice
export const updateMInvoice = (minvoice) =>
  api.put(url.UPDATE_MINVOICE + "/" + minvoice._id, minvoice);

// delete MInvoice
export const deleteMInvoice = (minvoice) =>
  api.delete(url.DELETE_MINVOICE + "/" + minvoice);

export const getMInvoiceByNumber = (minvoice) => {
  return api.get(url.GET_MINVOICE_BYNUMBER + "?ivid=" + minvoice);
};

// OrderInvoices
// get OrderInvoices
export const getOrderInvoices = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_ORDER_INVOICES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// add OrderInvoice
export const addNewOrderInvoice = (orderinvoice) =>
  api.create(url.ADD_NEW_ORDER_INVOICE, orderinvoice);

// update OrderInvoice
export const updateOrderInvoice = (orderinvoice) =>
  api.put(url.UPDATE_ORDER_INVOICE + "/" + orderinvoice._id, orderinvoice);

// delete OrderInvoice
export const deleteOrderInvoice = (orderinvoice) =>
  api.delete(url.DELETE_ORDER_INVOICE + "/" + orderinvoice);

export const getOrderInvoiceByNumber = (orderinvoice) => {
  return api.get(url.GET_ORDER_INVOICE_BYNUMBER + "?ivid=" + orderinvoice);
};

export const getOrderInvoiceByOrderId = (orderId) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    token = JSON.parse(authUser).accessToken;
  }
  return api.get(url.GET_ORDER_INVOICE_BYORDERID + "/" + orderId, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

// Bank Transactions
export const addNewBankTransactionRequest = (data) =>
  api.create(`${url.ADD_BANK_TRANSACTION_REQUEST}/${data.invoiceId}/bank-transactions`, data.transaction);

export const addNewBankTransactionByOrderRequest = (data) =>
  api.create(`${url.ADD_BANK_TRANSACTION_BY_ORDER_REQUEST}/${data.orderId}/bank-transactions`, data);

export const updateBankTransactionRequest = (data) =>
  api.put(`${url.UPDATE_BANK_TRANSACTION_REQUEST}/${data.invoiceId}/bank-transactions/${data.transactionId}`, data.transaction);

export const deleteBankTransactionRequest = (data) =>
  api.delete(`${url.DELETE_BANK_TRANSACTION_REQUEST}/${data.invoiceId}/bank-transactions/${data.transactionId}`);

export const getAdditionalInvoicesByOrderId = (orderId) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) token = JSON.parse(authUser).accessToken;
  return api.get(`${url.GET_ADDITIONAL_INVOICES_BY_ORDER}/${orderId}/additional-invoices`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const addAdditionalInvoiceByOrderId = (data) =>
  api.create(`${url.ADD_ADDITIONAL_INVOICE_BY_ORDER}/${data.orderId}/additional-invoices`, data);

export const createConsolidatedInvoice = (data) =>
  api.create(url.CREATE_CONSOLIDATED_INVOICE, data);

// Warehouses
// get Warehouses
export const getWarehouses = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const { companyName = "", type = "", startDate = "", endDate = "" } = filters;

  return api.get(url.GET_WAREHOUSES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      companyName,
      type,
      startDate,
      endDate,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

// add Warehouse
export const addNewWarehouse = (warehouse) =>
  api.create(url.ADD_NEW_WAREHOUSE, warehouse);

// update Warehouse
export const updateWarehouse = (warehouse) =>
  api.put(url.UPDATE_WAREHOUSE + "/" + warehouse._id, warehouse);

// delete Warehouse
export const deleteWarehouse = (warehouse) =>
  api.delete(url.DELETE_WAREHOUSE + "/" + warehouse);

// delete Warehouse Companies
export const getWarehousesCompanies = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_WAREHOUSES_COMPANIES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// get Warehouses Withdraw
export const getWarehousesWithdraw = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const { companyName = "", type = "", startDate = "", endDate = "" } = filters;

  return api.get(url.GET_WAREHOUSES_WITHDRAW, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      companyName,
      type,
      startDate,
      endDate,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

// add Warehouse Withdraw
export const addNewWarehouseWithdraw = (warehouse) =>
  api.create(url.ADD_NEW_WAREHOUSE_WITHDRAW, warehouse);

// update Warehouse Withdraw
export const updateWarehouseWithdraw = (warehouse) =>
  api.put(url.UPDATE_WAREHOUSE_WITHDRAW + "/" + warehouse._id, warehouse);

// delete Warehouse Withdraw
export const deleteWarehouseWithdraw = (warehouse) =>
  api.delete(url.DELETE_WAREHOUSE_WITHDRAW + "/" + warehouse);

// getWarehouses Report Summary
export const getWarehousesReportSummary = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const { companyName = "", type = "", startDate = "", endDate = "" } = filters;

  return api.get(url.GET_WAREHOUSES_SUMMARY, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      companyName,
      type,
      startDate,
      endDate,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

export const getWarehousesReportInvoice = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  const { companyName = "", type = "", startDate = "", endDate = "" } = filters;

  return api.get(url.GET_WAREHOUSES_INVOICE, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      companyName,
      type,
      startDate,
      endDate,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "comma" }),
  });
};

// Warehouse Invoices
// get WarehouseInvoices
export const getWarehousesInvoices = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_WAREHOUSES_INVOICES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// add WarehouseInvoice
export const addNewWarehousesInvoice = (invoice) =>
  api.create(url.ADD_NEW_WAREHOUSES_INVOICE, invoice);

// update WarehouseInvoice
export const updateWarehousesInvoice = (invoice) =>
  api.put(url.UPDATE_WAREHOUSES_INVOICE + "/" + invoice._id, invoice);

// delete WarehouseInvoice
export const deleteWarehousesInvoice = (invoice) =>
  api.delete(url.DELETE_WAREHOUSES_INVOICE + "/" + invoice);

// get getWarehousesInvoiceByNumber
export const getWarehousesInvoiceByNumber = (invoice) => {
  return api.get(url.GET_WAREHOUSES_INVOICE_BYNUMBER + "?ivid=" + invoice);
};

// ===================== Upload PDFs =====================
export const uploadPDFs = async ({ pdfFiles, category, uploadedBy }) => {
  const formData = new FormData();
  pdfFiles.forEach((file) => formData.append("pdfFiles", file));
  formData.append("category", category);
  formData.append("uploadedBy", uploadedBy);

  try {
    const res = await api.create(url.GET_UPLOAD, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      maxBodyLength: Infinity,
      maxContentLength: Infinity,
    });

    const data = res?.data ?? res;

    if (!data) {
      throw new Error("No data returned from upload API");
    }

    //console.log("Upload response:", data);
    return data; // this will now be used in the thunk
  } catch (err) {
    console.error("Upload failed:", err.response?.data || err.message || err);
    throw err;
  }
};

export const uploadPDFsTransport = async ({
  pdfFiles,
  category,
  uploadedBy,
  orderId,
}) => {
  const formData = new FormData();
  pdfFiles.forEach((file) => formData.append("pdfFiles", file));
  formData.append("category", category);
  formData.append("orderId", orderId);
  formData.append("uploadedBy", uploadedBy);

  try {
    const res = await api.create(url.GET_UPLOAD_TRANSPORT, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      maxBodyLength: Infinity,
      maxContentLength: Infinity,
    });

    const data = res?.data ?? res;

    if (!data) {
      throw new Error("No data returned from upload API");
    }

    //console.log("Upload response:", data);
    return data; // this will now be used in the thunk
  } catch (err) {
    console.error("Upload failed:", err.response?.data || err.message || err);
    throw err;
  }
};
// get Order by ID
export const getOrder = (id) => api.get(url.GET_ORDERS + "/" + id);

// update Files
export const updateFiles = (files) => {
  return api.put(url.UPDATE_FILE + "/" + "a15b00456n", files);
};

// ===================== Get Files =====================
export const getFiles = async ({ userId, category }) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) throw new Error("Authorization token is missing.");

  const params = {};
  if (userId) params.userId = userId;
  if (category) params.category = category;

  try {
    const res = await api.get(url.GET_FILES, {
      headers: { Authorization: `Bearer ${token}` },
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "comma" }),
    });

    // ✅ Important: return res.data, not res
    if (!res) throw new Error("No data returned from API");
    return res;
  } catch (err) {
    console.error("Get files failed:", err);
    throw err;
  }
};

export const getFilesTransport = async ({ orderId, category }) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) throw new Error("Authorization token is missing.");

  const params = {};
  if (orderId) params.orderId = orderId;
  if (category) params.category = category;

  try {
    const res = await api.get(url.GET_FILES_TRANSPORT, {
      headers: { Authorization: `Bearer ${token}` },
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "comma" }),
    });

    if (!res) throw new Error("No data returned from API");
    return res;
  } catch (err) {
    console.error("Get files failed:", err);
    throw err;
  }
};

export const deleteFile = (fileId) =>
  api.delete(`${url.DELETE_FILE}/${fileId}`);

// Notifications
// get Notifications
export const getNotifications = async ({ ntf_tunnel, page = 1 }) => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    try {
      const parsedUser = JSON.parse(authUser);
      token = parsedUser.accessToken;
    } catch (error) {
      console.error("Failed to parse authUser:", error);
    }
  }

  if (!token) throw new Error("Authorization token is missing.");

  const params = { page };
  if (ntf_tunnel) params.ntf_tunnel = ntf_tunnel;

  try {
    const res = await api.get(url.GET_NOTIFICATIONS, {
      headers: { Authorization: `Bearer ${token}` },
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "comma" }),
    });

    if (!res) throw new Error("No data returned from API");
    return res;
  } catch (err) {
    console.error("Notification API error:", err);
    throw err;
  }
};

// add Notification
export const addNewNotification = (notification) =>
  api.create(url.ADD_NEW_NOTIFICATION, notification);

// update Notification
export const updateNotification = ({ ids }) =>
  api.put(url.UPDATE_NOTIFICATION, { ids });

// delete Notification
export const deleteNotification = (notification) =>
  api.delete(url.DELETE_NOTIFICATION + "/" + notification);

// get EchangeRates
export const getExchangeRates = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_EXCHANGE_RATES, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

//Landing
export const getLanding = () => {
  const authUser = localStorage.getItem("authUser");

  let token;
  if (authUser) {
    const parsedUser = JSON.parse(authUser);

    token = parsedUser.accessToken;
  } else {
    console.log("No user data found in localStorage.");
  }
  if (!token) {
    throw new Error("Authorization token is missing.");
  }

  return api.get(url.GET_LANDING, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// add Landing
export const addNewLanding = (land) => api.create(url.ADD_NEW_LANDING, land);

// update Landing
export const updateLanding = (land) =>
  api.put(url.UPDATE_LANDING + "/" + land._id, land);

// delete Landing
export const deleteLanding = (land) =>
  api.delete(url.DELETE_LANDING + "/" + land);

// ========================== Temp Warehouses (GTA) ==========================

// get TempWarehouseDeposit
export const getTempWarehousesDeposit = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try {
      token = JSON.parse(authUser).accessToken;
    } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  const { companyName = "", type = "", startDate = "", endDate = "" } = filters;
  return api.get(url.GET_TEMP_WAREHOUSES_DEPOSIT, {
    headers: { Authorization: `Bearer ${token}` },
    params: { companyName, type, startDate, endDate },
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
  });
};

// add TempWarehouseDeposit
export const addNewTempWarehouseDeposit = (deposit) =>
  api.create(url.ADD_NEW_TEMP_WAREHOUSE_DEPOSIT, deposit);

// update TempWarehouseDeposit
export const updateTempWarehouseDeposit = (deposit) =>
  api.put(url.UPDATE_TEMP_WAREHOUSE_DEPOSIT + "/" + deposit._id, deposit);

// delete TempWarehouseDeposit
export const deleteTempWarehouseDeposit = (id) =>
  api.delete(url.DELETE_TEMP_WAREHOUSE_DEPOSIT + "/" + id);

// get TempWarehouseWithdraw
export const getTempWarehousesWithdraw = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try {
      token = JSON.parse(authUser).accessToken;
    } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  const { companyName = "", type = "", startDate = "", endDate = "" } = filters;
  return api.get(url.GET_TEMP_WAREHOUSES_WITHDRAW, {
    headers: { Authorization: `Bearer ${token}` },
    params: { companyName, type, startDate, endDate },
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
  });
};

// add TempWarehouseWithdraw
export const addNewTempWarehouseWithdraw = (withdraw) =>
  api.create(url.ADD_NEW_TEMP_WAREHOUSE_WITHDRAW, withdraw);

// update TempWarehouseWithdraw
export const updateTempWarehouseWithdraw = (withdraw) =>
  api.put(url.UPDATE_TEMP_WAREHOUSE_WITHDRAW + "/" + withdraw._id, withdraw);

// delete TempWarehouseWithdraw
export const deleteTempWarehouseWithdraw = (id) =>
  api.delete(url.DELETE_TEMP_WAREHOUSE_WITHDRAW + "/" + id);

// get TempWarehouse Summary
export const getTempWarehousesSummary = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try {
      token = JSON.parse(authUser).accessToken;
    } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  const {
    page = 1, pageSize = 50,
    startDate = "", endDate = "",
    rcStartDate = "", rcEndDate = "",
    rcDateFilter = "all",
    number = "", vagon = "", company = "", rc_receiver = "",
    activeType = "current",
  } = filters;
  return api.get(url.GET_TEMP_WAREHOUSES_SUMMARY, {
    headers: { Authorization: `Bearer ${token}` },
    params: { page, pageSize, startDate, endDate, rcStartDate, rcEndDate, rcDateFilter, number, vagon, company, rc_receiver, activeType },
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
  });
};

// add TempWarehouseSummary
export const addNewTempWarehouseSummary = (summary) =>
  api.create(url.ADD_NEW_TEMP_WAREHOUSE_SUMMARY, summary);

// update TempWarehouseSummary receiver location
export const updateReceiverLocation = (payload) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try { token = JSON.parse(authUser).accessToken; } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  return api.put(url.UPDATE_TEMP_WAREHOUSE_SUMMARY_LOCATION, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteLocationHistory = (payload) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try { token = JSON.parse(authUser).accessToken; } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  return api.delete(url.DELETE_TEMP_WAREHOUSE_LOCATION_HISTORY, {
    headers: { Authorization: `Bearer ${token}` },
    data: payload,
  });
};

// GET TempWarehouseDeposit list (GTAIn / Орлого)
export const getTempWarehousesDepositList = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try { token = JSON.parse(authUser).accessToken; } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  const {
    page = 1, pageSize = 50,
    startDate = "", endDate = "",
    number = "", vagon = "", company = "", rc_receiver = "",
    activeType = "all",
  } = filters;
  return api.get(url.GET_TEMP_WAREHOUSES_DEPOSIT_LIST, {
    headers: { Authorization: `Bearer ${token}` },
    params: { page, pageSize, startDate, endDate, number, vagon, company, rc_receiver, activeType },
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
  });
};

// Generate QR codes for all existing summary receivers without one
export const generateTempWarehouseSummaryQRCodes = () => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try { token = JSON.parse(authUser).accessToken; } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  return api.post(url.GENERATE_TEMP_WAREHOUSE_SUMMARY_QRCODES, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// GET GTA Location Map — Dashboard widget
export const getGtaLocationMap = () => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try { token = JSON.parse(authUser).accessToken; } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  return api.get(url.GET_GTA_LOCATION_MAP, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// GTA Release — Агуулахаас гаргах
export const gtaRelease = (payload) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try { token = JSON.parse(authUser).accessToken; } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  return api.create(url.GTA_RELEASE, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const gtaReleaseBulk = (payload) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try { token = JSON.parse(authUser).accessToken; } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  return api.create(url.GTA_RELEASE_BULK, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// GET TempWarehouseWithdraw list (GTAOut / Зарлага)
export const getTempWarehousesWithdrawList = (filters = {}) => {
  const authUser = localStorage.getItem("authUser");
  let token;
  if (authUser) {
    try { token = JSON.parse(authUser).accessToken; } catch (e) {}
  }
  if (!token) throw new Error("Authorization token is missing.");
  const {
    page = 1, pageSize = 50,
    startDate = "", endDate = "",
    number = "", vagon = "", company = "", rc_receiver = "",
  } = filters;
  return api.get(url.GET_TEMP_WAREHOUSES_WITHDRAW_LIST, {
    headers: { Authorization: `Bearer ${token}` },
    params: { page, pageSize, startDate, endDate, number, vagon, company, rc_receiver },
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
  });
};

// ========================== Job Posts ==========================
const getAuthToken = () => {
  const authUser = localStorage.getItem("authUser");
  if (!authUser) throw new Error("Authorization token is missing.");
  return JSON.parse(authUser).accessToken;
};

export const getJobPosts = (params = {}) => {
  const token = getAuthToken();
  return api.get(url.GET_JOB_POSTS, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
};

export const getJobPostsStats = () => {
  const token = getAuthToken();
  return api.get(url.GET_JOB_POSTS_STATS, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const addNewJobPost = (data) => api.create(url.ADD_NEW_JOB_POST, data);

export const updateJobPost = (data) =>
  api.put(`${url.UPDATE_JOB_POST}/${data._id}`, data);

export const updateJobPostStatus = (id, statusData) =>
  api.update(`${url.UPDATE_JOB_POST}/${id}/status`, statusData);

export const deleteJobPost = (id) =>
  api.delete(`${url.DELETE_JOB_POST}/${id}`);

// ========================== Job Applications ==========================
export const getJobApplications = (params = {}) => {
  const token = getAuthToken();
  return api.get(url.GET_JOB_APPLICATIONS, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
};

export const getJobApplicationsCounts = () => {
  const token = getAuthToken();
  return api.get(url.GET_JOB_APPLICATIONS_COUNTS, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateJobApplicationStatus = (id, status) =>
  api.update(`${url.UPDATE_JOB_APPLICATION_STATUS}/${id}/status`, { status });

export const deleteJobApplication = (id) => {
  const token = getAuthToken();
  return api.delete(`${url.UPDATE_JOB_APPLICATION_STATUS}/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateJobApplicationRemark = (id, remark) => {
  const token = getAuthToken();
  return api.update(`${url.UPDATE_JOB_APPLICATION_STATUS}/${id}/remark`, { remark }, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getJobApplicationFileUrl = (id) => {
  const token = getAuthToken();
  return `${axios.defaults.baseURL}/jobapplications/${id}/file?token=${encodeURIComponent(token)}`;
};

// ========================== News ==========================
export const getNews = (params = {}) => {
  const token = getAuthToken();
  return api.get(url.GET_NEWS, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
};

export const getNewsStats = () => {
  const token = getAuthToken();
  return api.get(url.GET_NEWS_STATS, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const addNews = (data) => {
  const token = getAuthToken();
  return api.create(url.ADD_NEWS, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateNews = (data) => {
  const token = getAuthToken();
  return axios.put(`${axios.defaults.baseURL}${url.UPDATE_NEWS}/${data._id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateNewsStatus = (id, status) => {
  const token = getAuthToken();
  return axios.patch(`${axios.defaults.baseURL}${url.UPDATE_NEWS}/${id}/status`, { status }, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteNews = (id) => {
  const token = getAuthToken();
  return api.delete(`${url.DELETE_NEWS}/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const uploadNewsCover = (formData) => {
  const token = getAuthToken();
  return api.create(url.UPLOAD_NEWS_COVER, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

// ========================== News Categories ==========================
export const getNewsCategories = () => {
  const token = getAuthToken();
  return api.get(url.GET_NEWS_CATEGORIES, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const addNewsCategory = (data) => {
  const token = getAuthToken();
  return api.create(url.ADD_NEWS_CATEGORY, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateNewsCategory = (data) => {
  const token = getAuthToken();
  return axios.put(`${axios.defaults.baseURL}${url.UPDATE_NEWS_CATEGORY}/${data._id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteNewsCategory = (id) => {
  const token = getAuthToken();
  return api.delete(`${url.DELETE_NEWS_CATEGORY}/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// ========================== Container Logs ==========================
export const getContainerLogsGetFilters = (filters = {}) => {
  const token = getAuthToken();
  const {
    action = "",
    priority = "",
    container_number = "",
    user_name = "",
    beginDate = "",
    endDate = "",
    conflicted = false,
    page = 1,
    pageSize = 30,
  } = filters;

  return api.get(url.GET_CONTAINERLOGS_GETFILTERS, {
    headers: { Authorization: `Bearer ${token}` },
    params: { action, priority, container_number, user_name, beginDate, endDate, conflicted, page, pageSize },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "comma" }),
  });
};

export const bulkDeleteContainerLogs = (ids = []) => {
  const token = getAuthToken();
  return api.delete(url.DELETE_CONTAINERLOGS_BULK, {
    headers: { Authorization: `Bearer ${token}` },
    data: { ids },
  });
};

// ========================== Orders Dashboard ==========================
export const getOrdersDashboardSummary = (params = {}) => {
  const token = getAuthToken();
  return api.get(url.GET_ORDERS_DASHBOARD_SUMMARY, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
};

export const getOrdersDashboardManagers = (params = {}) => {
  const token = getAuthToken();
  return api.get(url.GET_ORDERS_DASHBOARD_MANAGERS, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
};

export const getOrdersTransportStats = (params = {}) => {
  const token = getAuthToken();
  return api.get(url.GET_ORDERS_TRANSPORT_STATS, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
};
